import { gateway } from "../../../gateway";
import { KanbanCategory } from "../interfaces/kanbanCategory.interface";


export const getKanbanCategoriesAction = async (): Promise<KanbanCategory[]> => {
    try {
        const response = await gateway.get("/kanban-categories/self");
        return response.data?.data ?? response.data;
    } catch (error) {
        console.error("Error fetching kanban categories:", error);
        throw error;
    }
};  